/**
 * Configuration → Asset Catalog. The six processes behind create from files, refine with AI, the Asset Advisor and
 * research's asset matching, each with one part: the AI model it runs on. Their prompts live in code,
 * so there is no Prompt part.
 */

import { ProcessAssignments } from '@/routes/ai-models/ProcessAssignments';

import { ProcessWorkbench, type ProcessInfo, type ProcessPart } from './ProcessWorkbench';

/** The catalog's AI processes, in the order they run (backend app/ai/processes.py). */
export const ASSET_CATALOG_PROCESSES = ['catalog.extract', 'catalog.refine', 'advisor.needs', 'match.screen', 'match.deep', 'advisor.synthesis'] as const;

/** What the list shows a caller who may not read the assignments. */
const KNOWN: ProcessInfo[] = [
  { key: 'catalog.extract', name: 'Asset extraction', description: "Reads uploaded files and proposes one asset's fields, sections and success cases, with a quote for every claim.", has_prompt: false },
  { key: 'catalog.refine', name: 'Asset refinement', description: "Proposes changes to one asset's fields and sections from an editor's instruction and optional files.", has_prompt: false },
  { key: 'advisor.needs', name: 'Needs analysis', description: 'Restates a client problem, notes or an opportunity as a list of needs, with no client or person names.', has_prompt: false },
  { key: 'match.screen', name: 'Asset screening', description: "Scores every eligible asset's card against the needs, in batches, so no asset is skipped.", has_prompt: false },
  { key: 'match.deep', name: 'Asset deep analysis', description: "Reads each shortlisted asset's shareable content and evidence and says how it meets each need.", has_prompt: false },
  { key: 'advisor.synthesis', name: 'Advisor synthesis', description: 'Ranks the shortlist and notes combinations, such as an offer built from matched assets.', has_prompt: false },
];

const parts = (process: ProcessInfo): ProcessPart[] => [
  { key: 'model', label: 'AI model', permission: 'ai.processes.view', render: () => <ProcessAssignments processKeys={[process.key]} /> },
];

export function AssetCatalogTab() {
  return <ProcessWorkbench label="Asset Catalog processes" keys={ASSET_CATALOG_PROCESSES} parts={parts} known={KNOWN} />;
}
